import script from "./VUsersList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VUsersList.vue?vue&type=script&setup=true&lang=ts"

import "./VUsersList.vue?vue&type=style&index=0&id=7d07b2e7&lang=scss"

const __exports__ = script;

export default __exports__